<script setup lang="ts">
import PartIconCircle from '@parts/part-icon-circle.vue';
import { useRouter } from 'vue-router';
import {hapticFeedback} from "@tma.js/sdk-vue";
import { computed } from 'vue';
import isInTelegram from "@/utils/isInTelegram";

const router = useRouter();
const props = defineProps({
	fixed: {
		type: Boolean,
		default: false
	},
	showBackButton: {
		type: Boolean,
		default: false
	},
	disableBackButtonAction: {
		type: Boolean,
		default: false
	}
});
const emit = defineEmits(['back-button']);

const modes = computed(() => {
	return {
		'part-footer-navigation_fixed': props.fixed
	};
});

const routerBack = async() => {
	if (isInTelegram() && hapticFeedback.impactOccurred.isAvailable()) {
		hapticFeedback.impactOccurred('medium');
	}
	router.back();
}

const backButtonHandler = async () => {
	if (!props.disableBackButtonAction) {
		await routerBack();
	}
	emit('back-button');
}
</script>

<template>
	<div
		class="part-footer-navigation"
		:class="modes"
	>
		<part-icon-circle
			v-if="showBackButton"
			@click.native="backButtonHandler"
			light
			class="part-footer-navigation__back"
			:icon="{name: 'arrowLeft', viewBox: '0 0 13 22'}"
		/>
		<div class="part-footer-navigation__button">
			<slot />
		</div>
	</div>
</template>

<style lang="scss">
.part-footer-navigation {
    width: 100%;
    display: flex;
    gap: 2.1rem;
	// margin-top: auto;

	&_fixed {
		position: sticky;
		bottom: calc(1rem + var(--navigation-bar-height, 0rem));
		left: 0;
		width: 100%;
		@include min-desktop {
			bottom: 4rem;
		}
	}

	&__back {
		--button-size: 5.2rem;
		--button-icon-size: 0.8rem;
		flex: 0 0 auto;
		cursor: pointer;

		@include min-desktop {
			--button-size: 6.2rem;
		}
	}

	&__button {
		flex: 1 1 auto;
		& > * {
			width: 100%;
		}
		@include min-desktop {
			.button-primary {
				height: 6.2rem;
			}
		}
	}
}
</style>
